import React from 'react';

import {
  AutocompleteInput,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  TextInput,
  useTranslate,
} from 'react-admin';

import SubmitFilters from '../components/filters/SubmitFilters';
import DateRangeInput from '../components/inputs/DateRangeInput';
import { useFiltersStyles } from '../components/lists/useStyles';
import { usersConfig } from '../users';
import BookmakersInput from './inputs/BookmakersInput';

const Filters = ({ permissions, ...props }) => {
	const classes = useFiltersStyles();
	const translate = useTranslate();
	const isUser = permissions && permissions(["user"]);
	const getGroupByChoices = () => {
		let choices = [];
		if (!isUser) {
			choices.push({
				id: "user_id",
				name: translate("resources.users.name", 1),
			});
		}
		choices.push({
			id: "bookmaker_id",
			name: translate("resources.bookmakers.name", 1),
		});
		choices.push({
			id: "bookmaker_channel_id",
			name: translate("resources.stats.fields.channel", 1),
		});
		return choices;
	};

	return (
		<SubmitFilters {...props} classes={classes} spacerTop={false}>
			<DateRangeInput
				source="view"
				displayedFilters={props.displayedFilters}
				filterValues={props.filterValues}
				setFilters={props.setFilters}
				alwaysOn
				fullWidth
				box={{
					mr: 0,
				}}
			/>
			<SelectArrayInput
				source="group_by"
				choices={getGroupByChoices()}
				alwaysOn
				style={{ minWidth: 130 }}
			/>
			<ReferenceInput
				source="bookmaker_type_id"
				label="resources.bookmaker-deals.fields.bookmaker_type_id"
				reference="bookmaker-types"
				alwaysOn
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
				resettable
				sort={{ field: "name", order: "ASC" }}
				style={{ minWidth: 200 }}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<BookmakersInput />
			{permissions && permissions(["admin", "developer", "insights"]) && (
				<ReferenceInput
					source="user_id"
					reference="users"
					alwaysOn
					fullWidth
					allowEmpty
					label="resources.user-payments.fields.user_id_id"
					{...usersConfig.reference}
				>
					<AutocompleteInput optionText="name" />
				</ReferenceInput>
			)}
			<TextInput
				label="resources.stats.fields.channel"
				source="bookmaker_channel_name"
				fullWidth
				alwaysOn
			/>
		</SubmitFilters>
	);
};

export default Filters;
